import { actionTypes } from '../actions/prizes.action';
const initialState = {
    prizes: [],
    prize: {},
    result: {
        prize: {},
        transaction: {},
        user: {}
    },
    error: {},
    success: false
}

const PrizesReducer = (state = initialState, { type, payload }) => {
    switch (type) {

    case actionTypes.INDEX:

        return { ...state, ...payload }

    case actionTypes.UPDATE:
        let index = state.prizes.data.findIndex(item => item.id === payload.id)
        state.prizes.data[index] = payload

        return {
            ...state,
            prizes: {
                ...state.prizes,
                data: [
                    ...[(index < 0) && payload],
                    ...state.prizes.data
                ]
            }
        }

    case actionTypes.DESTROY:
        return {
            ...state,
            prizes: state.prizes.filter(item => item.id !== payload)
        }

    case actionTypes.CHANGE:
        return {
            ...state,
            prize: (payload === 'clear') ? {} : {
                ...state.prize,
                ...payload
            }
        }

    case actionTypes.SUCCESS:
        return {
            ...state,
            success: payload
        }

    case actionTypes.ERROR:
        return {
            ...state,
            error: payload
        }

    default:
        return state
    }
}

export default PrizesReducer